import {NgModule} from '@angular/core';
import {FreeDeliveryProgressComponent} from "../../components/free-delivery-progress/free-delivery-progress.component";
import {CommonModule} from '@angular/common';
import {CheckoutComponent} from "./checkout.component";
import {TextModule} from "../../components/text/text.module";
import {ButtonModule} from "../../components/button/button.module";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {TextInputModule} from "../../components/text-input/text-input.module";
import {ImageModule} from "../../components/image/image.module";
import {CheckoutService} from "./service/checkout.service";
import {ToastBarModule} from "../../components/toast-bar/toast-bar.module";
import {PrimaryButtonComponent} from "../../components/button/primary/primary.button.component";
import {ConfirmationModalModule} from "../../components/confirmation-modal/confirmation-modal.module";
import {SecondaryButtonComponent} from "../../components/button/secondary/secondary.button.component";
import {CheckboxModule} from "../../components/checkbox/checkbox.module";


@NgModule({
    declarations: [CheckoutComponent],
    imports: [
        FreeDeliveryProgressComponent,
        CommonModule,
        TextModule,
        ButtonModule,
        FormsModule,
        TextInputModule,
        ReactiveFormsModule,
        ImageModule,
        ToastBarModule,
        PrimaryButtonComponent,
        ConfirmationModalModule,
        SecondaryButtonComponent,
        CheckboxModule
    ],
    providers: [CheckoutService]
})
export class CheckoutModule {
}